var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-dialog',{ref:"changePassword",staticClass:"changePassword",attrs:{"title":'修改密码',"data-warden-title":"修改密码","confirmButtonText":'保存'}},[_c('change-password',{ref:"passForm"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05984ab7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/home/ChangePasswordPage.vue
// module id = null
// module chunks = 